// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".breadcrumbs{margin:.4rem 0 1.2rem;scroll-margin-top:75px}", "",{"version":3,"sources":["webpack://./src/Components/Breadcrumbs.scss"],"names":[],"mappings":"AAEA,aACE,qBAAA,CAEA,sBAAA","sourcesContent":["@import \"../variables\";\n\n.breadcrumbs {\n  margin: 0.4rem 0 1.2rem;\n  // adjust scroll to\n  scroll-margin-top: 75px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
